<template>
  <div class="lawerDetail">
    <div class="container">
      <div class="intro">
        <div class="name">{{name}}</div>
        <div class="title">{{eliteEnumId==1?getIndexData.fixedFieldMap['elite.partner']:getIndexData.fixedFieldMap['elite.lawyer']}}</div>
        <!-- <div class="address">中国中山</div> -->
        <div class="phone">
          <i class="iconfont icon-youxiang"></i>
          <span>{{email}}</span>
        </div>
        <div class="eamil">{{email}}</div>
        <div class="pic">
          <img :src="cover" alt="">
        </div>
      </div>
      <div class="nav-icon-text">
        <i class="active iconfont icon-index-copy"></i>
        <span class="active">{{getIndexData.fixedFieldMap['elite.introduction']}}</span>
        <i class="iconfont icon-youjiantou"></i>
        <span class="active">{{eliteEnumId==1?getIndexData.fixedFieldMap['elite.partner']:getIndexData.fixedFieldMap['elite.lawyer']}}</span>
        <i class="iconfont icon-youjiantou"></i>
        <span>{{name}}</span>
      </div>
      <div class="resume">
        <div class="title">{{getIndexData.fixedFieldMap['elite.introduction']}}</div>
        <div class="cont" v-html="label">
          {{label}}
        </div>
      </div>
      <!-- <div class="resume">
          <div class="title">个人简历</div>
          <div class="cont">
          　　XXX：本科学历，小学语文高级教师。从事 21年，一向担任语文教学兼班主任工作。曾获省、市教研教改先进个人，益阳市“优秀班主任”等光荣称号，多次被学校评为“优秀教师”、“先进德育工作者”。撰写的经验论文多次获国家、省、市级一、二等奖。如《 的小树叶》获全国教师范文一等奖，《班主任工作浅谈》获市优秀论文一等奖，辅导 作文大赛二等奖。2001年参与编写的《九年义务教育六年制小学多媒体教学软件》已由省教育音像出版社出版发行。她坚信：爱是打开学生
          </div>
      </div> -->
    </div>
  </div>
</template>


<script>
import {mapGetters} from 'vuex'
  export default {
    data: () => ({
      cover: '',
      eliteEnumId:'',
      eliteEnumName: '',
      email: '',
      iphome: '',
      label: '',
      name: '',
      nameEn: '',

    }),
    computed: {
      ...mapGetters(['getIndexData']),
    },
    created() {
      this.$$$api.detailDetail({id: this.$route.params.id}).then(res => {
        console.log("res:" + res)
        var req=res.data.data;
        this.cover = req.cover;
        this.eliteEnumName=req.eliteEnumName;
        this.eliteEnumId=req.eliteEnumId;
        this.email=req.email;
        this.iphome=req.iphome;
        this.label=req.label;
        this.name=req.name;
        this.nameEn=req.nameEn;
        if('en'==localStorage.langType){
          this.name=req.nameEn;
          this.label=req.labelEn;
        }else if("zh"==localStorage.langType){
          this.name=req.name;
          this.label=req.label;
        }

      })
    }
  }
</script>


<style lang="stylus">
  @import "~styl/mixin.styl"

  theme = #f7aa05

  .lawerDetail
    h(800)
    bg(#fff)
    mt(110)
    pt(40)
    ppr()
    box()
    fs(0)

    .container
      container()

      .resume
        .title
          font-weight 700
          fs(18)
          pt(20)
          pb(20)

        .cont
          fs(14)
          c(rgb(130, 130, 130))
          fs(15)
          lh(18)

      .nav-icon-text
        border-top 1px solid rgba(0, 0, 0, .1)
        border-bottom 1px solid rgba(0, 0, 0, .1)
        pt(8)
        pb(8)
        mt(30)

        .active
          c(theme)

        i
          fs(15)

        span
          pl(10)
          pr(10)
          fs(15)
          _hover()

      .intro
        ppr()
        h(240)

        .name
          fs(30)
          c(rgb(37, 37, 37))
          font-weight 700

        .title
          fs(18)
          font-weight 600
          c(rgb(70, 70, 70))
          pt(10)
          pb(20)

        .address
          fs(18)
          c(theme)
          width 50%

        .phone
          pt(25)
          pb(5)

          i
            fs(16)

          span
            fs(15)
            pl(8)

        .eamil
          fs(14)
          c(theme)

        .pic
          ppa()
          top 0
          bottom 0
          w(250)
          right 0

          img
            wh()

</style>



// WEBPACK FOOTER //
// src/components/lawerDetail/index.vue